import { NavLink, useHistory } from 'react-router-dom';
import './_SideNavSubscriberPortal.scss';
import { ISideNavProps } from '../../types/ISideNavSubscriberPortal';
import { Col } from 'react-bootstrap';

function SideNavSubscriberPortal({
  navLinkItems,
  open,
  onLinkClick,
}: ISideNavProps) {
  const history = useHistory();

  return (
    <Col
      className={
        open
          ? 'side-nav-subscriber-portal sidenav-open'
          : 'side-nav-subscriber-portal sidenav-close'
      }
      data-testid="side-nav-subscriber-portal"
    >
      <ul>
        {navLinkItems.map(({ url, label, submenus, icon, ariaLabel }) => (
          <li key={label} onClick={onLinkClick}>
            <NavLink
              tabIndex={0}
              key={label}
              exact
              to={{ pathname: url }}
              className={
                submenus?.filter(
                  (item) => history.location.pathname === item.url,
                ).length
                  ? 'nav-link link-active'
                  : 'nav-link'
              }
              activeClassName="link-active"
            >
              <span className="active-strip"></span>
              <img src={icon} alt={label} aria-label={ariaLabel} />
              {label}
              <i
                className={`custom-chevron fas ${
                  history.location.pathname === url ||
                  submenus?.filter(
                    (item) => history.location.pathname === item.url,
                  ).length
                    ? 'fa-chevron-down'
                    : 'fa-chevron-right'
                }`}
              ></i>
            </NavLink>
            {history.location.pathname === url ||
            submenus?.filter((item) => history.location.pathname === item.url)
              .length
              ? submenus?.map(({ url, label }) => {
                  return (
                    <NavLink
                      tabIndex={0}
                      key={label}
                      exact
                      to={() => url}
                      onClick={() => {
                        onLinkClick;
                      }}
                      className="submenu-nav-link"
                      activeClassName="submenu-link-active"
                    >
                      <span className="active-strip"></span>
                      {label}
                    </NavLink>
                  );
                })
              : null}
          </li>
        ))}
      </ul>
    </Col>
  );
}

export default SideNavSubscriberPortal;
